import clsx from "clsx";

import { type Level } from "@features/overview-v2/types";
import { BreakdownSelector } from "@features/sales-v3/shared";
import { type TopLevelBreakdown } from "@features/sales-v3/types";
import { type CategoricalBreakdownConfig } from "@north-beam/nb-common";

interface Props {
  breakdownConfigs: CategoricalBreakdownConfig[];
  breakdowns: TopLevelBreakdown[];
  labelsByLevel?: Record<string, Level>;
  disabled?: boolean;
  onChange(values: TopLevelBreakdown[]): void;
}

export const FilterButtonSelect = ({
  breakdownConfigs,
  breakdowns,
  labelsByLevel,
  disabled,
  onChange,
}: Props) => (
  <BreakdownSelector
    mode="breakdowns-and-values"
    breakdownConfigs={breakdownConfigs}
    selectedBreakdowns={breakdowns}
    buttonContentComponent={ButtonContentComponent}
    buttonClassName="button sm secondary-button font-bold"
    buttonActiveClassName="button sm secondary-button font-bold bg-cosmic text-white border-cosmic"
    menuPlacement="bottom-start"
    labelsByLevel={labelsByLevel}
    disabled={disabled}
    onSelectionChange={onChange}
  />
);

const ButtonContentComponent = ({ isOpen }: { isOpen: boolean }) => (
  <>
    <i
      className={clsx("fa-regular fa-sharp fa-circle-plus mr-1.5", {
        "text-white": isOpen,
      })}
    />
    ADD FILTER
  </>
);
